import React from 'react';
import { ArrowRight } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  showIcon?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  size = 'lg',
  showIcon = false,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold transition-all duration-200 rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer';
  const variants = {
    primary: 'bg-amber-500 hover:bg-amber-600 text-white shadow-lg hover:shadow-xl hover:-translate-y-0.5 focus:ring-amber-500',
    secondary: 'bg-stone-800 hover:bg-stone-900 text-white shadow-md hover:shadow-lg focus:ring-stone-800',
    outline: 'bg-transparent border-2 border-amber-600 text-amber-700 hover:bg-amber-50 focus:ring-amber-500'
  };
  const sizes = {
    sm: 'px-4 py-2 text-sm',
    md: 'px-6 py-3 text-base',
    lg: 'px-8 py-4 text-lg',
    xl: 'px-10 py-5 text-xl w-full sm:w-auto'
  };
  return <a href="#pricing" className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} data-id="element-189">
      {children}
      {showIcon && <ArrowRight className="ml-2 h-5 w-5" data-id="element-190" />}
    </a>;
}